import {    SET_WRITE_DATA, 
            SET_IS_ALARM_SET_MAIN,
            SET_IS_ALARM_SET_PSM1,
            SET_IS_ALARM_SET_PSM2,
            SET_IS_ALARM_SET_PSM3,
            SET_IS_ALARM_SET_PSM4,
            SET_IS_ALARM_SET_PSM5,
            SET_CURR_ALARM_MAIN,
            SET_CURR_ALARM_PSM1,
            SET_CURR_ALARM_PSM2,
            SET_CURR_ALARM_PSM3,
            SET_CURR_ALARM_PSM4,
            SET_CURR_ALARM_PSM5,
            SET_PREV_ALARM_MAIN,
            SET_PREV_ALARM_PSM1,
            SET_PREV_ALARM_PSM2,
            SET_PREV_ALARM_PSM3,
            SET_PREV_ALARM_PSM4,
            SET_PREV_ALARM_PSM5,
            // [UPDATE] TE900C ENABLE 260105
            SET_TE900C_ENABLE_PSM1,
            SET_TE900C_ENABLE_PSM2,
            SET_TE900C_ENABLE_PSM3,
            SET_TE900C_ENABLE_PSM4,
            SET_TE900C_ENABLE_PSM5
        } 
        
        from "../constants/actions";

export const setWriteData = (write_data) => ({
    type: SET_WRITE_DATA,
    write_data: write_data
});

// [UPDATE] BUGFIX display alarm label 250813
export const setIsAlarmSetMAIN = (isAlarmSetMAIN) => (
    {
        type: SET_IS_ALARM_SET_MAIN,
        isAlarmSetPSM1: isAlarmSetMAIN
    }
);

export const setIsAlarmSetPSM1 = (isAlarmSetPSM1) => (
    {
        type: SET_IS_ALARM_SET_PSM1,
        isAlarmSetPSM1: isAlarmSetPSM1
    }
);

export const setIsAlarmSetPSM2 = (isAlarmSetPSM2) => (
    {
        type: SET_IS_ALARM_SET_PSM2,
        isAlarmSetPSM2: isAlarmSetPSM2
    }
);

export const setIsAlarmSetPSM3 = (isAlarmSetPSM3) => (
    {
        type: SET_IS_ALARM_SET_PSM3,
        isAlarmSetPSM3: isAlarmSetPSM3
    }
);

export const setIsAlarmSetPSM4 = (isAlarmSetPSM4) => (
    {
        type: SET_IS_ALARM_SET_PSM4,
        isAlarmSetPSM4: isAlarmSetPSM4
    }
);

export const setIsAlarmSetPSM5 = (isAlarmSetPSM5) => (
    {
        type: SET_IS_ALARM_SET_PSM5,
        isAlarmSetPSM5: isAlarmSetPSM5
    }
);

export const setCurrAlarmMAIN = (currAlarmMAIN) => (
    {
        type: SET_CURR_ALARM_MAIN,
        currAlarmMAIN: currAlarmMAIN
    }
);

export const setCurrAlarmPSM1 = (currAlarmPSM1) => (
    {
        type: SET_CURR_ALARM_PSM1,
        currAlarmPSM1: currAlarmPSM1
    }
);

export const setCurrAlarmPSM2 = (currAlarmPSM2) => (
    {
        type: SET_CURR_ALARM_PSM2,
        currAlarmPSM2: currAlarmPSM2
    }
);

export const setCurrAlarmPSM3 = (currAlarmPSM3) => (
    {
        type: SET_CURR_ALARM_PSM3,
        currAlarmPSM3: currAlarmPSM3
    }
);

export const setCurrAlarmPSM4 = (currAlarmPSM4) => (
    {
        type: SET_CURR_ALARM_PSM4,
        currAlarmPSM4: currAlarmPSM4
    }
);

export const setCurrAlarmPSM5 = (currAlarmPSM5) => (
    {
        type: SET_CURR_ALARM_PSM5,
        currAlarmPSM5: currAlarmPSM5
    }
);

export const setPrevAlarmMAIN = (prevAlarmMAIN) => (
    {
        type: SET_PREV_ALARM_MAIN,
        prevAlarmMAIN: prevAlarmMAIN
    }
);

export const setPrevAlarmPSM1 = (prevAlarmPSM1) => (
    {
        type: SET_PREV_ALARM_PSM1,
        prevAlarmPSM1: prevAlarmPSM1
    }
);

export const setPrevAlarmPSM2 = (prevAlarmPSM2) => (
    {
        type: SET_PREV_ALARM_PSM2,
        prevAlarmPSM2: prevAlarmPSM2
    }
);

export const setPrevAlarmPSM3 = (prevAlarmPSM3) => (
    {
        type: SET_PREV_ALARM_PSM3,
        prevAlarmPSM3: prevAlarmPSM3
    }
);

export const setPrevAlarmPSM4 = (prevAlarmPSM4) => (
    {
        type: SET_PREV_ALARM_PSM4,
        prevAlarmPSM4: prevAlarmPSM4
    }
);

export const setPrevAlarmPSM5 = (prevAlarmPSM5) => (
    {
        type: SET_PREV_ALARM_PSM5,
        prevAlarmPSM5: prevAlarmPSM5
    }
);


// [UPDATE] TE900C Enable 260105
export const setTE900CEnablePSM1 = (TE900CEnablePSM1) => (
    {
        type: SET_TE900C_ENABLE_PSM1,
        TE900CEnablePSM1: TE900CEnablePSM1
    }
);
export const setTE900CEnablePSM2 = (TE900CEnablePSM2) => (
    {
        type: SET_TE900C_ENABLE_PSM2,
        TE900CEnablePSM2: TE900CEnablePSM2
    }
);
export const setTE900CEnablePSM3 = (TE900CEnablePSM3) => (
    {
        type: SET_TE900C_ENABLE_PSM3,
        TE900CEnablePSM3: TE900CEnablePSM3
    }
);
export const setTE900CEnablePSM4 = (TE900CEnablePSM4) => (
    {
        type: SET_TE900C_ENABLE_PSM4,
        TE900CEnablePSM1: TE900CEnablePSM4
    }
);
export const setTE900CEnablePSM5 = (TE900CEnablePSM5) => (
    {
        type: SET_TE900C_ENABLE_PSM5,
        TE900CEnablePSM5: TE900CEnablePSM5
    }
);
